import {Typography} from '~library/atoms/Typography';
import {Colors} from './Colors';

export const RecentColors = ({
  colors,
  onClick,
  highlight,
  disabled,
  isLargishAndUp,
  selectedColor,
  size,
}) => {
  if (!isLargishAndUp)
    return (
      <Colors
        width={size}
        height={size}
        colors={colors}
        onClick={onClick}
        highlight={highlight}
        disabled={disabled}
        selectedColor={selectedColor}
      />
    );

  return (
    <div className="color-picker__recent-colors">
      {isLargishAndUp && (
        <Typography variant="label3" color="pebble">
          Recently Used
        </Typography>
      )}
      <Colors
        width={size}
        height={size}
        colors={colors}
        onClick={onClick}
        highlight={highlight}
        disabled={disabled}
        selectedColor={selectedColor}
      />
    </div>
  );
};
